import { AuthUser, UserAccessResource } from 'services/resources';
import request from '../../request'; // local module at root of app.

/**
 * Authenticates a user if the credentials are correct
 */
export function authenticate(username, password) {
  return request('auth/login/', {
    method: 'POST',
    data: {
      username,
      password,
    },
  });
}

/**
 * Authenticates a contactless guest if the auth_token is correct
 */
export function authenticateGuestToken(contactlessToken) {
  return request(`auth/guest_user/`, {
    method: 'POST',
    data: {
      token: contactlessToken,
    },
  });
}

/**
 * Checks the user Authentication token and returns the user
 */
export function retrieveAuthenticatedUser() {
  return request<AuthUser>('auth/whoami/', {
    method: 'GET',
  });
}

/**
 * Sends a password reset request
 *
 * @param {string} email
 */
export function passwordResetRequest(email) {
  return request('auth/password/reset/', {
    method: 'POST',
    data: {
      email,
    },
  });
}

/**
 * Resets a user password
 *
 * @param {string} uid
 * @param {string} token
 * @param {string} password
 * @param {string} passwordConfirmation
 */
export function passwordReset(uid, token, password, passwordConfirmation) {
  return request('auth/password/reset/confirm/', {
    method: 'POST',
    data: {
      uid,
      token,
      new_password1: password,
      new_password2: passwordConfirmation,
    },
    noKeyTransform: true,
  });
}

export function accountActivation(firstname, lastname, password, passwordConfirmation, token, uid) {
  return request('auth/activate/', {
    method: 'POST',
    data: {
      uid,
      token,
      firstName: firstname,
      lastName: lastname,
      password1: password,
      password2: passwordConfirmation,
    },
  });
}

export function listAccess(authToken: string) {
  return request<UserAccessResource>('auth/list_access/', {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
}
